import { GameObjectAttributes } from '../CustomAttributes';

// Terrains
export const [road, water, yard_grass, graveyard, park_grass, trail] = [
  'road',
  'water',
  'yard_grass',
  'grave_yard',
  'park_grass',
  'trail',
];

// Landscapes (and roaming creatures)
export const [
  short_pine,
  tall_pine,
  fall_oak,
  oak,
  sapling,
  blackberry_bush,
  cross,
  crossA,
  crossB,
  grave,
  graveA,
  graveB,
  graveC,
  graveD,
  graveE,
  brown_rock,
  grey_rock,
] = [
  'short_pine',
  'tall_pine',
  'fall_oak',
  'oak',
  'sapling',
  'blackberry_bush',
  'cross',
  'cross_a',
  'cross_b',
  'grave',
  'grave_a',
  'grave_b',
  'grave_c',
  'grave_d',
  'grave_e',
  'brown_rock',
  'grey_rock',
];

// Drop items (and released creatures)
export const [
  walnuts,
  blackberries,
  persimmon,
  pawpaw,
  mushroom,
  shroom,
  hole,
  heart,
  bat,
  ghost,
  lobster,
  crab,
  bass,
  gar,
  squirrel,
  raven,
  gouhl,
  octopus,
  skeleton,
  skull
] = [
  'walnuts',
  'blackberries',
  'persimmon',
  'pawpaw',
  'mushroom',
  'shroom',
  'hole',
  'heart',
  'bat',
  'ghost',
  'lobster',
  'crab',
  'bass',
  'gar',
  'squirrel',
  'raven',
  'gouhl',
  'octopus',
  'skeleton',
  'skull'
];

export const name_to_tile_id = new Map<string, number>([
  [road, 308],
  [water, 568],
  [yard_grass, 741],
  [graveyard, 872],
  [park_grass, 801],
  [trail, 113],
]);

export const tile_id_to_tile_name = new Map<number, string>();
name_to_tile_id.forEach((value, key) => {
  tile_id_to_tile_name.set(value, key);
});

export const tile_name_to_available_objects = new Map<string, string[]>([
  [road, []],
  [water, [grey_rock, bass, gar]],
  [yard_grass, [brown_rock, tall_pine, oak, oak, squirrel]],
  [graveyard, [cross, grave, graveA, graveB, graveC, graveD, graveE]],
  [
    park_grass,
    [
      brown_rock,
      brown_rock,
      blackberry_bush,
      sapling,
      short_pine,
      oak,
      squirrel,
    ],
  ],
  [trail, []],
]);

// Types of things
export const [tree, stone, item, creature, enemy] = [
  'tree',
  'stone',
  'item',
  'creature',
  'enemy',
];

// type: string, shakes: boolean, mass: number, health: integer, drops: string[]
export const name_to_attributes = new Map<string, GameObjectAttributes>([
  [short_pine, new GameObjectAttributes(tree, true, -1, 2, [bat], false)],
  [tall_pine, new GameObjectAttributes(tree, true, -1, 2, [bat], false)],
  [fall_oak, new GameObjectAttributes(tree, true, -1, 3, [persimmon, raven], false)],
  [
    oak,
    new GameObjectAttributes(
      tree,
      true,
      -1,
      3,
      [persimmon, raven, bat],
      false
    ),
  ],
  [
    sapling,
    new GameObjectAttributes(
      tree,
      true,
      -1,
      2,
      [pawpaw, pawpaw, pawpaw, bat],
      false
    ),
  ],
  [
    blackberry_bush,
    new GameObjectAttributes(
      tree,
      true,
      -1,
      2,
      [blackberries, blackberries, raven],
      false
    ),
  ],
  [
    cross,
    new GameObjectAttributes(
      stone,
      true,
      -1,
      1,
      [mushroom, mushroom, shroom, bat, ghost],
      false
    ),
  ],
  [
    grave,
    new GameObjectAttributes(
      stone,
      true,
      -1,
      2,
      [mushroom, shroom, shroom, bat, ghost],
      false
    ),
  ],
  [
    graveA,
    new GameObjectAttributes(
      stone,
      true,
      -1,
      2,
      [mushroom, shroom, shroom, bat, ghost],
      false
    ),
  ],
  [
    graveB,
    new GameObjectAttributes(
      stone,
      true,
      -1,
      2,
      [mushroom, shroom, shroom, bat, ghost],
      false
    ),
  ],
  [
    graveC,
    new GameObjectAttributes(
      stone,
      true,
      -1,
      2,
      [mushroom, shroom, shroom, bat, ghost],
      false
    ),
  ],
  [
    graveD,
    new GameObjectAttributes(
      stone,
      true,
      -1,
      2,
      [mushroom, shroom, shroom, bat, ghost],
      false
    ),
  ],
  [
    graveE,
    new GameObjectAttributes(
      stone,
      true,
      -1,
      2,
      [mushroom, shroom, shroom, bat, ghost],
      false
    ),
  ],
  [
    brown_rock,
    new GameObjectAttributes(stone, true, 1500, 1, [brown_rock] , false),
  ],
  [
    grey_rock,
    new GameObjectAttributes(stone, true, 1500, 1, [lobster, crab], false),
  ],
  [walnuts, new GameObjectAttributes(item, false, -1, 1, [], false)],
  [blackberries, new GameObjectAttributes(item, false, -1, 1, [], false)],
  [persimmon, new GameObjectAttributes(item, false, -1, 1, [], false)],
  [pawpaw, new GameObjectAttributes(item, false, 15, 1, [], false)],
  [mushroom, new GameObjectAttributes(item, false, 15, 1, [], false)],
  [shroom, new GameObjectAttributes(item, false, 15, 1, [], false)],
  [lobster, new GameObjectAttributes(item, false, -1, 1, [], false)],
  [crab, new GameObjectAttributes(item, false, -1, 1, [], false)],
  [hole, new GameObjectAttributes(item, false, 15, 1, [], false)],
  [heart, new GameObjectAttributes(item, false, 15, 1, [], false)],
  [bat, new GameObjectAttributes(creature, true, 15, 2, [mushroom, mushroom, heart], true)],
  [ghost, new GameObjectAttributes(creature, true, 15, 5, [mushroom, shroom], true)],
  [gar, new GameObjectAttributes(creature, true, 15, 1, [heart, crab], false)],
  [bass, new GameObjectAttributes(creature, true, 15, 1, [lobster], false)],
  [squirrel, new GameObjectAttributes(creature, true, 15, 2, [heart], false)],
  [raven, new GameObjectAttributes(creature, true, 15, 5, [blackberries], true)],
  [gouhl, new GameObjectAttributes(creature, true, 15, 12, [skull], true, false)],
  [octopus, new GameObjectAttributes(creature, true, 15, 3, [heart, heart, crab, lobster], true, false)],
  [skeleton, new GameObjectAttributes(creature, true, 15, 25, [skull], true, false)],
]);
